import { COMPONENT_TYPE } from 'common/constants';
import { transformElementDefaults } from 'utils/facades/utils';
import type { ComponentTypes } from 'types/story';
import { adUnit } from './ad-unit/recipe';
import { answer } from './answer/recipe';
import { answerInput } from './answer-input/recipe';
import { answerProgress } from './answer-progress/recipe';
import { box } from './box/recipe';
import { button } from './button/recipe';
import { buttonSubmit } from './button-submit/recipe';
import { card } from './card/recipe';
import { checkbox } from './checkbox/recipe';
import { cmsRepeater } from './cms-repeater/recipe';
import { content } from './content/recipe';
import { counter } from './counter/recipe';
import { embed } from './embed/recipe';
import { fileUploadField } from './file-upload-field/recipe';
import { floatAbove } from './float-above/recipe';
import { floatBelow } from './float-below/recipe';
import { googleLogin } from './google-login/recipe';
import { image } from './image/recipe';
import { lottie } from './lottie/recipe';
import { overlay } from './overlay/recipe';
import { resultText } from './result-text/recipe';
import { resultShape } from './result-shape/recipe';
import { searchField } from './search-field/recipe';
import { select } from './select/recipe';
import { shape } from './shape/recipe';
import { share } from './share/recipe';
import { slider } from './slider/recipe';
import { sliderArrow } from './slider-arrow/recipe';
import { sliderPagination } from './slider-pagination/recipe';
import { sliderSlides } from './slider-slides/recipe';
import { sortableBox } from './sortable-box/recipe';
import { smsLogin } from './sms-login/recipe';
import { swipe } from './swipe/recipe';
import { text } from './text/recipe';
import { textAreaField } from './text-area-field/recipe';
import { textField } from './text-field/recipe';
import { timer } from './timer/recipe';
import { video } from './video/recipe';
import { visualCompare } from './visual-compare/recipe';
import type { CreatedBuildingBlock, CreationContextFor } from './creation-types';

type BuildingBlockRecipes = {
	[T in ComponentTypes]: (context: CreationContextFor<T>) => CreatedBuildingBlock<T>;
};

const recipes: BuildingBlockRecipes = {
	[COMPONENT_TYPE.AD_UNIT]: adUnit,
	[COMPONENT_TYPE.ANSWER]: answer,
	[COMPONENT_TYPE.ANSWER_INPUT]: answerInput,
	[COMPONENT_TYPE.ANSWER_PROGRESS]: answerProgress,
	[COMPONENT_TYPE.BOX]: box,
	[COMPONENT_TYPE.BUTTON]: button,
	[COMPONENT_TYPE.BUTTON_SUBMIT]: buttonSubmit,
	[COMPONENT_TYPE.CARD]: card,
	[COMPONENT_TYPE.CHECKBOX]: checkbox,
	[COMPONENT_TYPE.CMS_REPEATER]: cmsRepeater,
	[COMPONENT_TYPE.CONTENT]: content,
	[COMPONENT_TYPE.COUNTER]: counter,
	[COMPONENT_TYPE.EMBED]: embed,
	[COMPONENT_TYPE.FILE_UPLOAD_FIELD]: fileUploadField,
	[COMPONENT_TYPE.FLOAT_ABOVE]: floatAbove,
	[COMPONENT_TYPE.FLOAT_BELOW]: floatBelow,
	[COMPONENT_TYPE.GOOGLE_LOGIN]: googleLogin,
	[COMPONENT_TYPE.RESULT_TEXT]: resultText,
	[COMPONENT_TYPE.RESULT_SHAPE]: resultShape,
	[COMPONENT_TYPE.SEARCH_FIELD]: searchField,
	[COMPONENT_TYPE.SELECT]: select,
	[COMPONENT_TYPE.SHARE]: share,
	[COMPONENT_TYPE.SMS_LOGIN]: smsLogin,
	[COMPONENT_TYPE.TEXT]: text,
	[COMPONENT_TYPE.TEXT_AREA_FIELD]: textAreaField,
	[COMPONENT_TYPE.TEXT_FIELD]: textField,
	[COMPONENT_TYPE.IMG]: image,
	[COMPONENT_TYPE.LOTTIE]: lottie,
	[COMPONENT_TYPE.SLIDER]: slider,
	[COMPONENT_TYPE.SLIDER_ARROW]: sliderArrow,
	[COMPONENT_TYPE.SLIDER_PAGINATION]: sliderPagination,
	[COMPONENT_TYPE.SLIDER_SLIDES]: sliderSlides,
	[COMPONENT_TYPE.OVERLAY]: overlay,
	[COMPONENT_TYPE.SHAPE]: shape,
	[COMPONENT_TYPE.SORTABLE_BOX]: sortableBox,
	[COMPONENT_TYPE.SWIPE]: swipe,
	[COMPONENT_TYPE.TIMER]: timer,
	[COMPONENT_TYPE.VIDEO]: video,
	[COMPONENT_TYPE.VISUAL_COMPARE]: visualCompare,
};

export const createBuildingBlock = <T extends ComponentTypes>(
	type: T,
	context: CreationContextFor<T>
): CreatedBuildingBlock<T> => {
	return transformElementDefaults(context.defaultPlatform, recipes[type](context));
};
